export interface PaletteColor {
  key: string
  value: string | null
}

export const TEXT_COLORS: PaletteColor[] = [
  { key: 'default', value: null },
  { key: 'blue', value: '#1460AA' },
  { key: 'dark_blue', value: '#004791' },
  { key: 'orange', value: '#D97F18' },
  { key: 'green', value: '#0C8A1E' },
  { key: 'red', value: '#DC0909' },
  { key: 'grey', value: '#6B7580' },
  { key: 'black', value: '#2C3135' },
]

export const HIGHLIGHT_COLORS: PaletteColor[] = [
  { key: 'none', value: null },
  { key: 'yellow', value: '#ffe066' },
  { key: 'light_blue', value: '#D3E6F8' },
  { key: 'light_green', value: '#D1F8CB' },
  { key: 'light_orange', value: '#FFF5DE' },
  { key: 'pink', value: '#FEE2E2' },
  { key: 'light_grey', value: '#DEE8F2' },
]

export const DEFAULT_TEXT_COLOR = '#2C2C2C'
export const DEFAULT_HIGHLIGHT_COLOR = '#ffe066'

export const FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32]

export const DEFAULT_HEIGHT = 400

export const TOOLBAR_POPOVER_OVERRIDES = { Body: { style: { zIndex: 1000 } } }

export const CHANGE_DEBOUNCE_MS = 250
